import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonSharedComponent } from './button.component';
import { ButtonAtomSharedComponent } from './button-atom.component';
import { IconSharedModule } from '../icon/icon.module';
import { SpinnerSharedModule } from '../spinner/spinner.module';
import { ButtonIconSharedComponent } from './button-icon.component';

@NgModule({
    declarations: [
        ButtonSharedComponent,
        ButtonAtomSharedComponent,
        ButtonIconSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        SpinnerSharedModule
    ],
    exports: [
        ButtonSharedComponent,
        ButtonAtomSharedComponent,
        ButtonIconSharedComponent
    ]
})

export class ButtonSharedModule {}
